export interface LegalDocumentDto {
  type: string;
  version: string;
  title: string;
}

export interface ConsentAcceptancePayload {
  documentType: string;
  documentVersion: string;
}

export const REQUIRED_CONSENT_ACCEPTANCES_COUNT = 2;

export const DEFAULT_LEGAL_DOCUMENTS: LegalDocumentDto[] = [
  { type: 'terms_of_use', version: '1.0.0', title: 'Termos de Uso' },
  { type: 'privacy_policy', version: '1.0.0', title: 'Política de Privacidade' }
];

export function hasRequiredAcceptances(acceptances: ConsentAcceptancePayload[]): boolean {
  return acceptances.length >= REQUIRED_CONSENT_ACCEPTANCES_COUNT;
}

export interface ConsentPendingItem {
  documentType: string;
  version: string;
  title: string;
}

export interface ConsentStatusDto {
  accepted: Array<{
    documentType: string;
    documentVersion: string;
    acceptedAt: string;
  }>;
  pending: ConsentPendingItem[];
}

export const LEGAL_SLUGS = {
  terms: { title: 'Termos de Uso', markdownPath: '/assets/legal/terms.md' },
  privacy: { title: 'Política de Privacidade', markdownPath: '/assets/legal/privacy.md' },
  cookies: { title: 'Política de Cookies', markdownPath: '/assets/legal/cookies.md' }
} as const;

export type LegalSlug = keyof typeof LEGAL_SLUGS;

export function isLegalSlug(value: string): value is LegalSlug {
  return value in LEGAL_SLUGS;
}

export function legalSlugFromDocumentType(type: string): LegalSlug | null {
  const map: Record<string, LegalSlug> = {
    terms_of_use: 'terms',
    privacy_policy: 'privacy',
    cookie_policy: 'cookies'
  };

  return map[type] ?? null;
}

export interface LegalDocumentDialogData {
  slug: LegalSlug;
}
